import React from 'react'
import styled from '@emotion/styled'

import { fontWeightSemibold, fontSize2XSmall, redBase } from '../../constants/principles'
import checkmark from './blackCheck.svg'

import DoneModal from '../generic/modals/DoneModal'
import { ModalContentNormal } from '../generic/Basics.js'

export default ({ setShowModal, lastChange, systemChanges, tedChanges, vinModalInfo, duplicateInfo }) => {
  const showModal = tedChanges && !!lastChange && lastChange.length > 0 && !!systemChanges && systemChanges.length > 0 && !!vinModalInfo && !vinModalInfo.vinModal && !duplicateInfo
  return (
    <DoneModal
      name={'OptionsModal'}
      title={'One (or more) options have changed.'}
      subtitle={tedChanges ? 'Options have changed based on your selection.' : "When you made a new selection, certain options replaced other options. Or sometimes options can't be chosen together."}
      onClick={e => setShowModal(false)}
      open={showModal}
      informational={true}>
      <FontSizedContentDiv>
        {lastChange && (
          <>
            Option(s) selected:
            <OptionDiv>
              {lastChange.map(option => (
                <OptionLine key={option.displayName} option={option} />
              ))}
            </OptionDiv>
          </>
        )}
        {systemChanges && (
          <>
            Option(s) that changed:
            <OptionDiv>
              {systemChanges.map(option => (
                <OptionLine key={option.displayName} option={option} />
              ))}
            </OptionDiv>
          </>
        )}
      </FontSizedContentDiv>
    </DoneModal>
  )
}

const OptionLine = ({ option }) =>
  option.isSelected ? (
    <SelectedDiv>
      <StyledImg alt="check" src={checkmark} />
      {option.displayName}
    </SelectedDiv>
  ) : (
    <UnselectedDiv>{option.displayName}</UnselectedDiv>
  )

const FontSizedContentDiv = styled(ModalContentNormal)`
  font-size: ${fontSize2XSmall};
`
const OptionDiv = styled.div`
  padding-top: 8px;
  padding-bottom: 16px;
`

const UnselectedDiv = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  color: ${redBase};
  text-decoration: line-through;
  padding-top: 4px;
  padding-bottom: 4px;
`
const SelectedDiv = styled.div`
  font-size: ${fontSize2XSmall};
  font-weight: ${fontWeightSemibold};
  padding-top: 4px;
  padding-bottom: 4px;
`
const StyledImg = styled.img`
  width: 16px;
  height: 16px;
  display: inline;
  vertical-align: middle;
  padding-right: 4px;
`
